export default __webpack_public_path__ + "static/media/home2.09e5f0da.jpg";